import { render, staticRenderFns } from "./queryKzx.vue?vue&type=template&id=3aaa4688&scoped=true&"
import script from "./queryKzx.vue?vue&type=script&lang=js&"
export * from "./queryKzx.vue?vue&type=script&lang=js&"
import style0 from "./queryKzx.vue?vue&type=style&index=0&id=3aaa4688&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaa4688",
  null
  
)

export default component.exports